import { createJSONStorage, devtools, persist } from "zustand/middleware";
import { immer } from "zustand/middleware/immer";

import { create } from "@/lib/store";
import { GeoViewToggle, MetricType } from "@/shared/types";
import { BusinessUnitToggle } from "@/shared/types";
import { hashStorage } from "@/shared/utils/hashStorage";

const STORE_NAME = "Scenario Results";

const DEFAULT_COLUMNS = [
  "business_unit",
  "channel",
  "funnel_stage",
  "geography",
  "spend",
  "revenue",
  "roi",
  "volume",
  "roas",
];

interface ScenarioResultsState {
  grid: {
    geoView: GeoViewToggle;
    businessUnitToggle: BusinessUnitToggle;
    activeColumns: string[];
    metricType: MetricType;
  };
}

interface ScenarioResultsActions {
  setGeoView: (geoView: GeoViewToggle) => void;
  setBusinessUnitToggle: (toggle: BusinessUnitToggle) => void;
  setActiveColumns: (columns: string[]) => void;
  setMetricType: (metricType: MetricType) => void;
}

type ScenarioResultsStore = ScenarioResultsState & ScenarioResultsActions;

const defaultState: ScenarioResultsState = {
  grid: {
    geoView: GeoViewToggle.AGGREGATE,
    businessUnitToggle: BusinessUnitToggle.AGGREGATE,
    activeColumns: DEFAULT_COLUMNS,
    metricType: MetricType.MARKETING_ROI,
  },
};

export const useScenarioResultsStore = create<ScenarioResultsStore>()(
  devtools(
    persist(
      immer((set) => ({
        ...defaultState,
        setGeoView: (geoView) =>
          set((state) => {
            state.grid.geoView = geoView;
          }),
        setBusinessUnitToggle: (businessUnitToggle) =>
          set((state) => {
            state.grid.businessUnitToggle = businessUnitToggle;
          }),
        setActiveColumns: (columns) =>
          set((state) => {
            state.grid.activeColumns = columns;
          }),
        setMetricType: (metricType) =>
          set((state) => {
            state.grid.metricType = metricType;
          }),
      })),
      {
        name: STORE_NAME,
        storage: createJSONStorage(() => hashStorage),
      }
    ),
    { name: STORE_NAME }
  )
);
